<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Select your handle';
                }
            },
            component_id: {
                default(){
                    return 'hardware_handle';
                }
            },
            slab: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            openingDirection: {
                required: true
            },
            hardwareSuite: {
                required: true
            },
            doorRange: {
                required: true
            },
            profile: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareColour, this.securedByDesign, this.openingDirection, this.hardwareSuite, this.doorRange, this.profile);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-handle?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&hardware_colour=' + this.hardwareColour + '&opening_direction=' + this.openingDirection + '&hardware_suite=' + this.hardwareSuite + '&door_range=' + this.doorRange + '&profile=' + this.profile;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.openingDirection + '_' + this.hardwareSuite + '_' + this.doorRange + '_' + this.profile;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'openingDirection': function (val, oldVal) {
                this.update_options();
            },
            'hardwareSuite': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'profile': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
